module.exports = __webpack_public_path__ + "media/theme/sc_nintendo-2cfea56f.png";